export default class Merchant {
  /**
   * Create new merchant and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * Search and match the string on urls to create a list of separate urls
   *
   * @return {Array}
   */
  get merchantUrls () {
    return this.merchantUrl ? this.merchantUrl.match(/(?:https?:\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+/igm) : []
  }

  /**
   * Search and match the string on urls to create a list of separate urls
   *
   * @return {Array}
   */
  get supportUrls () {
    return this.supportUrl ? this.supportUrl.match(/(?:https?:\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+/igm) : []
  }
}
